const modulePaymentSel = (state: any) => state.paySimplePayment;

export const authorizedSel = (state: any) => modulePaymentSel(state).authorized;
export const trackingNumberSel = (state: any) =>
  modulePaymentSel(state).trackingNumber;
export const errorMessageSel = (state: any) =>
  modulePaymentSel(state).errorMessage;

export const showStatusModalSel = (state: any) =>
  modulePaymentSel(state).showStatusModal;
export const errorSel = (state: any) => modulePaymentSel(state).error;
export const isPendingSel = (state: any) => modulePaymentSel(state).isPending;
